export default {
  // any array should have unique values as the values are used as keys
  // months
  formattedShortMonths: [
    'Tam',
    'Hel',
    'Maa',
    'Huh',
    'Tou',
    'Kes',
    'Hei',
    'Elo',
    'Syy',
    'Lok',
    'Mar',
    'Jou',
  ],
  months: [
    'Tammikuu',
    'Helmikuu',
    'Maaliskuu',
    'Huhtikuu',
    'Toukokuu',
    'Kesäkuu',
    'Heinäkuu',
    'Elokuu',
    'Syyskuu',
    'Lokakuu',
    'Marraskuu',
    'Joulukuu',
  ],
  months_calendar: {
    January: 'Tammikuu',
    February: 'Helmikuu',
    March: 'Maaliskuu',
    April: 'Huhtikuu',
    May: 'Toukokuu',
    June: 'Kesäkuu',
    July: 'Heinäkuu',
    August: 'Elokuu',
    September: 'Syyskuu',
    October: 'Lokakuu',
    November: 'Marraskuu',
    December: 'Joulukuu',
  },
  // weekdays
  weekdays: ['Su', 'Ma', 'Ti', 'Ke', 'To', 'Pe', 'La'],
  weekdays_booking_container: {
    Sunday: 'Sunnuntai',
    Monday: 'Maanantai',
    Tuesday: 'Tiistai',
    Wednesday: 'Keskiviikko',
    Thursday: 'Torstai',
    Friday: 'Perjantai',
    Saturday: 'Lauantai',
  },
  weekdays_calendar: {
    Sun: 'Su',
    Mon: 'Ma',
    Tue: 'Ti',
    Wed: 'Ke',
    Thu: 'To',
    Fri: 'Pe',
    Sat: 'La',
  },
  // additional translations
  today: 'Tänään',
  tomorrow: 'Huomenna',
};
